import type { ToastIconName } from 'types/ToastData';

import { toastIcons } from './toastIcons';

export function isToastIconName(name: string): name is ToastIconName {
  return Object.keys(toastIcons).includes(name);
}
